export default __webpack_public_path__ + "static/media/Kanha_national_park_3.726b38c1.jpg";